import React from 'react';
import {
  OverlayTrigger,
  Popover,
  Panel
} from 'react-bootstrap';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';

import './StockList.scss';

class StockListPanel extends React.Component {
  handlePublish(car, modelId) {
    this.props.handlePublish(car, modelId);
  }

  handleUnpublish(car, modelId) {
    this.props.handleUnpublish(car, modelId);
  }

  tooltip(carId, colorPrice, variantPrice, carAdjustmentPrice) {
    const tooltip = (
      <Popover id={carId} title="Prisinfo">
        Variantpris: <strong>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(variantPrice)},-</strong><br/>
        Fargetillegg: <strong>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(colorPrice)},-</strong><br/>
        Lagret justering: <strong>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(carAdjustmentPrice)},-</strong>
      </Popover>
    );

    return tooltip;
  }

  render() {
    return (
      <Panel.Body className="mg-panel-body">
        <div className="table-reponsive">
          <Link
            className='btn btn-default'
            to={`/modeller/${this.props.makeId}/modell/${this.props.model.id}`}
          >
            Gå til {this.props.model.name} <i className="fa fa-arrow-right"></i>
          </Link>
          <table className="table">
            <thead>
              <tr>
                <th>Navn</th>
                <th>Antall</th>
                <th>Farge</th>
                <th>Fargegruppe</th>
                <th>Interiør</th>
                <th>Utstyrsnivå</th>
                <th>Variant</th>
                <th>Pris (uten fraktpåslag)</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.props.cars.map((car, carKey) => {
                // console.log(car);
                let cls = 'warning';
                if (car.published) {
                  cls = 'success';
                  if (car.updated) {
                    cls = 'info';
                  }
                } else if (car.archived) {
                  cls = 'danger';
                }
                // If car has override color, use this
                // Else, use the original color from import
                car.color = car.colorOriginal;
                if (car.colorOverride) {
                  car.color = car.colorOverride;
                }

                // If car is missing some crucial elements, disable publish-button
                const enablePublish = (car.color && car.variant);

                // Handle color
                let color = <span className="text-danger">Mangler farge</span>;
                let colorGroup = '';

                if (car.color) {
                  if (car.color.colorGroup) {
                    colorGroup = car.color.colorGroup;
                  }

                  let colorOverrideInfo = '';
                  if (car.colorOverride) {
                    colorOverrideInfo = <span className="fa fa-info-circle" style={{paddingLeft: '10px'}} title="Fargen er satt manuelt"></span>;
                  }

                  color = <span><Link
                    to={`/farge/${car.color.id}/${car.model.id}`}
                    title='Rediger farge'
                  >
                    {car.color.name}
                  </Link>
                  {colorOverrideInfo}
                  </span>;
                }

                let colorStatus = false;
                if (car.color) {
                  colorStatus = <PublishStatusDot entry={car.color} />;
                }

                let interior = <span className="text-info">-</span>;
                if (car.interior) {
                  interior = <Link
                    to={`/equipmentFactory/${car.interior.id}`}
                    title='Rediger interiør'
                  >
                    {car.interior.name}
                  </Link>;
                }

                let interiorStatus = false;
                if (car.interior) {
                  interiorStatus = <PublishStatusDot entry={car.interior} />;
                }

                // Handle eqLevel
                let eqLevel = <span className="text-danger">Mangler utstyrsnivå</span>;
                if (car.equipmentLevel) {
                  eqLevel = <Link
                    to={`/equipmentlevel/${car.equipmentLevel.id}`}
                    title='Rediger utstyrsnivå'
                  >
                    {car.equipmentLevel.name}
                  </Link>;
                }

                let eqStatus = false;
                if (car.equipmentLevel) {
                  eqStatus = <PublishStatusDot entry={car.equipmentLevel} />;
                }

                // Handle variant
                let variant = <span className="text-danger">Mangler variant</span>;
                if (car.variant && car.variant.variantGroup) {
                  variant = <Link
                    to={`/variant/${car.variant.id}`}
                    title='Rediger variant'
                  >
                    {car.variant.name}
                  </Link>;
                }


                let variantStatus = false;
                if (car.variant) {
                  variantStatus = <PublishStatusDot entry={car.variant} />;
                }

                // Prices, prices, prices...
                let variantPrice = 0;
                if (car.variant) {
                  variantPrice = parseInt(car.variant.price, 10);
                }
                let colorPrice = 0;
                if (car.color) {
                  if (car.color.priceAdjustment) {
                    colorPrice = parseInt(car.color.priceAdjustment, 10);
                  }
                }

                let priceFormatted = null;
                if (colorPrice > 0 || variantPrice > 0) {
                  priceFormatted = Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(colorPrice + variantPrice + car.priceAdjustment);
                }

                let publishButtonClass = '';
                let unPublishButtonClass = '';
                if (car.published) {
                  publishButtonClass = ' hidden';
                }
                if (car.draft) {
                  unPublishButtonClass = ' hidden';
                }
                if (car.updated) {
                  unPublishButtonClass = ' hidden';
                  publishButtonClass = '';
                }

                return (
                  <tr key={carKey} className={cls} data-car={car.id}>
                    <td>
                      <Link
                        to={`/cars-in-stock/${this.props.make.toLowerCase()}/${car.id}`}
                      >
                        {car.title}
                      </Link>
                    </td>
                    <td>{car.stock}</td>
                    <td>{colorStatus} {color}</td>
                    <td>{colorGroup}</td>
                    <td>{interiorStatus} {interior}</td>
                    <td>{eqStatus} {eqLevel}</td>
                    <td>{variantStatus} {variant}</td>
                    <td>
                      {priceFormatted &&
                        <div className="price-data">
                          {priceFormatted},- <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={this.tooltip(car.id, colorPrice, variantPrice, car.priceAdjustment)}>
                            <i className="fa fa-question-circle" aria-hidden="true"></i>
                          </OverlayTrigger>
                        </div>
                      }
                    </td>
                    <td className="text-right">
                      {enablePublish &&
                        <div>
                          {this.props.workingId && this.props.workingId === car.id &&
                            <span><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;</span>
                          }

                          <button
                            type="button"
                            className={`btn btn-success${publishButtonClass}`}
                            disabled={(car.published && !car.updated) || this.props.working}
                            onClick={() => this.handlePublish(car, car.model.id)}
                          >
                            <span>Publiser</span>
                          </button>

                          <button
                            type="button"
                            className={`btn btn-warning${unPublishButtonClass}`}
                            disabled={(car.draft || this.props.working)}
                            onClick={() => this.handleUnpublish(car, car.model.id)}
                          >
                            <span>Avpubliser</span>
                          </button>
                        </div>
                      }
                      {!enablePublish &&
                        <button
                          type="button"
                          className="btn btn-info"
                        >
                          <span>Kan ikke publisere</span>
                        </button>
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Panel.Body>
    );
  }
}

export default StockListPanel;
